import { render, staticRenderFns } from "./talentManagement.vue?vue&type=template&id=48c7ec7e&scoped=true"
import script from "./talentManagement.vue?vue&type=script&lang=js"
export * from "./talentManagement.vue?vue&type=script&lang=js"
import style0 from "./talentManagement.vue?vue&type=style&index=0&id=48c7ec7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7ec7e",
  null
  
)

export default component.exports